<section class="relative w-full h-full">
    <div
        #actionSheet
        class="fixed safe-bottom bottom-0 left-0 w-full bg-white rounded-t-2xl"
    >
        <app-action-sheet-header
            [multiple]="multiple()"
            (reset)="reset()"
            (close)="close()"
            >{{ title() ? title() : "선택" }}</app-action-sheet-header
        >
        <div class="w-full h-px bg-gray-200"></div>
        @for (option of options(); track option.label) {
            @if (multiple()) {
                <app-action-sheet-multiple-option
                    [currentValue]="values()"
                    [option]="option"
                    (click)="handleClick(option)"
                />
            } @else {
                <app-action-sheet-option
                    [currentValue]="currentValue()"
                    [renderItem]="renderItem()"
                    [option]="option"
                    (click)="handleClick(option)"
                />
            }
        }
        @if (multiple()) {
            <div class="flex gap-3 items-center p-4">
                <app-button
                    (click)="cancel()"
                    expand
                    variant="outline"
                    color="gray"
                    >취소</app-button
                >
                <app-button (click)="apply()" expand>확인</app-button>
            </div>
        }
    </div>
</section>
